import React, { Suspense } from "react";
import { Node_Type } from "./../../ricos-types/index.js";
const Gallery = React.lazy(
  () => import(
    /* webpackChunkName: "ricos_plugin_gallery_lazy" */
    "./gallery.js"
  )
);
const GalleryRenderer = ({
  node,
  nodeIndex,
  NodeViewContainer,
  ...props
}) => {
  return /* @__PURE__ */ React.createElement(
    Gallery,
    {
      key: node.id,
      node,
      nodeIndex,
      NodeViewContainer,
      ...props
    }
  );
};
const GalleryLazy = ({ node, ...props }) => {
  return /* @__PURE__ */ React.createElement(Suspense, { fallback: "" }, /* @__PURE__ */ React.createElement(GalleryRenderer, { key: node.id, node, ...props }));
};
const nodeViewRenderers = {
  [Node_Type.GALLERY]: GalleryLazy
};
export {
  nodeViewRenderers
};
//# sourceMappingURL=node-view-renderers-lazy.js.map
